module.exports = __webpack_public_path__ + "email-footer.png";